var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToothDentist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.85,88.13a33.73,33.73,0,0,0-56.3-25.07c-7.81,4.87-16.64,2.55-19,.31a33.71,33.71,0,0,0-51.9,41.95l1.15,1.92L52,108.92c.11.15,11,15.68,14.29,44,0,0,0,0,0,.06,0,9.93,7.89,24.65,18.79,24.65,9.75,0,17.08-11.78,18.52-21.37l0-.6.13-.75a8.72,8.72,0,0,0,.1-1.74c.22-2.94.57-5.76,1-8.36a6.19,6.19,0,0,1,6-4.28s4.33-.19,6.07,4.75c.4,2.47.73,5.12.94,7.89a11,11,0,0,0,.24,2v2l.25,1.37c1.44,9.6,8.54,19.1,18.29,19.1,10.89,0,18.78-14.72,18.78-24.65v-.06c3.3-28.28,14.17-43.81,14.28-44L171,107l1.13-1.67A33.6,33.6,0,0,0,176.85,88.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothDentist);
export default __webpack_public_path__ + "static/media/TOOTH_DENTIST.6117123fb8d93442ebf1e676a34e0aa0.svg";
export { ForwardRef as ReactComponent };